import styles from '../assets/styles/card.module.css'
import Backarrow from '../components/Backarrow';

/** Landing pad for the cards icon on Home — picks between the built-in
 *  Robot Name Quiz and the embedded FRC Deal card game (see FrcDeal.js).
 *  Reuses Card.js's styling (card.module.css) so it
 *  reads as the same "games" surface instead of a one-off screen. */
function Games({ currentTab, setCurrentTab }) {
    if (currentTab !== "games") return;

    return (
        <div className="subpage cardPage">
            <div className={styles.cardGrid}>
                <div className={styles.cardTitle}>Games</div>
                <div className={styles.cardGameBox}>
                    <div className={styles.startMenu}>
                        <button className={styles.cardNextBtn} onClick={() => setCurrentTab("card")}>
                            Robot Name Quiz
                        </button>
                        <button className={styles.cardNextBtn} onClick={() => setCurrentTab("frcdeal")}>
                            FRC Deal
                        </button>
                    </div>
                </div>
            </div>

            <Backarrow setCurrentTab={setCurrentTab} />
        </div>
    );
}
export default Games;
